document.addEventListener(
    "DOMContentLoaded",
    function () {
        import("./core/details").then((module) => {
            module.init();
        });

        import("./core/button").then((module) => {
            module.init();
        });
    }
);
